import React, { useState, useEffect, useRef } from "react";
import { NavLink } from "react-router-dom";
import Styles from "../../assets/css/Pages/Services.module.css";
import { Helmet } from "react-helmet-async";
// Loaders
import Loading from "../Loadings/Loading";
// Global Imports
import { useGlobalState } from "../../Functions/GlobalStates";

const Services = () => {
  // States Here
  const [IsLoaded, setIsLoaded] = useState(false); // I CAN use this to show loading before all images loads
  // Global States Here //////////////////////////////////////////////////////...............................
  const {
    CheckPage,
    setCheckPage,
    DontAllow,
    setDontAllow,
    PagesWidthHeight,
    setPagesWidthHeight,
  } = useGlobalState();

  // React Referrences
  const CheckPageStateRef = useRef(false); // Ref for the check Page

  // Show And Hide Navbar DropMenu HomePage
  useEffect(() => {
    const handleCheckResize = () => {
      if (!CheckPageStateRef.current) {
        CheckPageStateRef.current = true;
        setCheckPage(true);
        setDontAllow(true);
      }
      // console.log("oN Mount", CheckPageStateRef.current);
      // console.log("Mounted User Entered");
    };
    handleCheckResize(); // call on mount

    // Add the resize event listener
    window.addEventListener("resize", handleCheckResize);

    // Update global state when the component unmounts , It mean when The user Leaves This Page
    return () => {
      if (CheckPageStateRef.current) {
        CheckPageStateRef.current = false;
        setCheckPage(true);
        setDontAllow(false);
      }
      // console.log("oN unMOUNT", CheckPageStateRef.current);
      // console.log("Unmounted User Leaved");
      window.removeEventListener("resize", handleCheckResize);
    };
  }, []);

  const PagesImages = require.context(
    "../../assets/images/Pages/Services/Ai-Images",
    false,
    /\.(png|jpe?g|gif|bmp|webp|svg|avif)$/
  );
  const PageImages = [
    PagesImages("./1.avif"),
    PagesImages("./2.avif"),
    PagesImages("./3.avif"),
    PagesImages("./4.avif"),
    PagesImages("./5.avif"),
    PagesImages("./6.avif"),
    PagesImages("./7.avif"),
  ];
  // Preload Images Before render it will help to descrease flickers on img change
  useEffect(() => {
    const preloadImages = async (imageArray, callback) => {
      try {
        await Promise.all(
          imageArray.map((src) => {
            return new Promise((resolve, reject) => {
              const img = new Image();
              img.src = src;
              img.onload = resolve;
              img.onerror = reject; // Add error handling
            });
          })
        );
        callback(); // Callback after all images are preloaded
      } catch (error) {
        console.error("Error preloading image:", error);
      }
    };

    preloadImages([PageImages[0]], () => {
      setIsLoaded(true); // Set state when all images are loaded
      // console.log("All Images Are Loaded");
    });
  });
  return IsLoaded ? (

    <>
      <Helmet>
        {/* Page Title */}
        <title>Our Services – Affiliators 🛠️</title>

        {/* Meta Description */}
        <meta
          name="description"
          content="Explore the wide range of digital services offered by Affiliators, including e-commerce guidance, SEO, and online business support."
        />

        {/* Keywords */}
        <meta
          name="keywords"
          content="affiliators services, digital solutions, ecommerce help, SEO services, online business support"
        />

        {/* Responsive Design */}
        <meta name="viewport" content="width=device-width, initial-scale=1" />

        {/* Open Graph Tags */}
        <meta property="og:title" content="Our Services – Affiliators 🛠️" />
        <meta
          property="og:description"
          content="Explore the digital services we provide to help your online business grow."
        />
        <meta property="og:type" content="website" />
        <meta
          property="og:url"
          content="https://affiliators.netlify.app/#/services"
        />

        {/* Image Meta Tags for Social Sharing */}
        {/*
    <meta
      property="og:image"
      content="/images/services/services.png"
    />
    <meta
      name="twitter:image"
      content="/images/services/services.png"
    />
    */}

        {/* Twitter Tags */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Our Services – Affiliators 🛠️" />
        <meta
          name="twitter:description"
          content="Discover how Affiliators can help with your e-commerce and digital goals."
        />

        {/* Indexing and Canonical URL */}
        <meta name="robots" content="index, follow" />
        {/* <link
          rel="canonical"
          href="https://affiliators.netlify.app/#/services"
        /> */}

        {/* Author and Language */}
        <meta name="author" content="Zeeshan Ahmad Kamran" />
        <meta name="language" content="en" />
        <meta httpEquiv="Content-Language" content="en" />
      </Helmet>

      <div className={Styles.ServicesContainer}>
        <section className={Styles.ServicesSection1}>
          <h1>Services</h1>
          <div className={Styles.ServicesSection1ImgPara1Container}>
            <img src={PageImages[0]} alt="Welcome To My Website" />
            <p>
              At Bloggers.com, we offer a range of services to help you find the
              best solutions, products, and recommendations for your daily needs.
            </p>
          </div>
          <div className={Styles.ServicesSection1HeadingImgPara1Container}>
            <h2>Expert Gift Guides</h2>
            <div className={Styles.ServicesSection1ImgPara2Container}>
              <img src={PageImages[1]} alt="Welcome To My Website" />
              <p>
                We provide well-researched gift guides to help you find the
                perfect present for any occasion, ensuring your choices are
                thoughtful and valuable.
              </p>
            </div>
          </div>
          <div className={Styles.ServicesSection1HeadingImgPara2Container}>
            <h2>Problem-Solving Blogs</h2>
            <div className={Styles.ServicesSection1ImgPara3Container}>
              <img src={PageImages[3]} alt="Welcome To My Website" />
              <p>
                Our blog covers a wide range of practical solutions for common
                challenges, helping you make informed decisions effortlessly.
              </p>
            </div>
          </div>
          <div className={Styles.ServicesSection1HeadingImgPara3Container}>
            <h2>Product Recommendations</h2>
            <div className={Styles.ServicesSection1ImgPara4Container}>
              <img src={PageImages[6]} alt="Welcome To My Website" />
              <p>
                We suggest high-quality products based on in-depth research,
                making it easier for you to select items that fit your needs and
                lifestyle.
              </p>
            </div>
          </div>
          <div className={Styles.ServicesSection1HeadingImgPara4Container}>
            <h2>Real-Life Gadgets & Daily Needs</h2>
            <div className={Styles.ServicesSection1ImgPara5Container}>
              <img src={PageImages[1]} alt="Welcome To My Website" />
              <p>
                We recommend useful gadgets and essential products designed to
                improve your daily activities, ensuring convenience and
                efficiency.
              </p>
            </div>
          </div>

          <h2>Affiliate Disclosure</h2>
          <p>
            Some of our recommendations contain affiliate links, meaning we may
            earn a small commission at no extra cost to you. We only recommend
            products that we genuinely believe offer value.
          </p>

          <h2>Customer Support</h2>
          <p>
            If you have any questions about our Services, please contact us at{" "}
            <NavLink to="/customer-support">Contact us</NavLink>
          </p>
        </section>
      </div>
    </>
  ) : (
    <Loading />
  );
};

export default Services;
